import { useState } from "react";
import { Button, Card, CardBody, Col } from "reactstrap";
import { FileFilter } from "../../../../constants";
import { FileManagerLists } from "../../../../data/applications/FileManager";
import BottomList from "./BottomList";

const SideBar = () => {
  const [IsOpen, setIsOpen] = useState(false);

  return (
    <Col xl="3">
      <div className="md-sidebar">
        <Button color="primary" className="md-sidebar-toggle" onClick={() => setIsOpen(!IsOpen)}>
          {FileFilter}
        </Button>
        <div className={`md-sidebar-aside custom-scrollbar ${IsOpen ? "open" : ""}`}>
          <div className="file-sidebar">
            <Card>
              <CardBody>
                <ul>
                  {/* Mapping through FileManagerLists to display dynamic list of available options to get files */}
                  {FileManagerLists.map((item, i) => (
                    <li key={i}>
                      <Button className={item.className} color={item.Name}>
                        {item.icon}
                        {item.title}
                      </Button>
                    </li>
                  ))}
                </ul>
                <hr />
                <BottomList />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default SideBar;
